import React from "react";
import { useAppSelector, useAppDispatch } from "@app/state";
import Button from "devextreme-react/button";
import "./super.scss";
export const SuperAdminShowCase = () => {
  return (
    <div id={"suShowCasePage"}>
      <div id="calloutToAtelierImg" />
      <div id="nop">
        <div id="calloutToAtelierText">
          <h1>Atelier</h1>
          <div className="callout-wrapper">
            <p>
              Deschide pagina <b>DevPage</b> din <em>Atelier</em>.
            </p>
            <p>
              Vezi daca sunt rapoarte definite in <em>ATELIER</em>{" "}
              neinregistrate in <em>JGAP</em>.{" "}
            </p>
            <p>
              Se preiau in interfata aceasta doar lucarile inregistrate.{" "}
              <span>
                Dupa ce ai inregistrat in <em>JGAP</em> raportul, poti sa
                modifici vizibilitatea si categoriile la care se adreseaza
              </span>
            </p>
            <Button
              text="ATELIER/ PAGINA DE DEZVOLTARE"
              icon="preferences"
              onClick={() => {
                if (process.env.NODE_ENV === "development") {
                  window.open(
                    `http://localhost:3001/?page=admin0`,
                    "showcase",
                    ""
                  );
                } else {
                  window.open(
                    `https://admin.jurnalgold.ro/reports/?page=admin0`,
                    "showcase",
                    ""
                  );
                }
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
